<div
	*ngFor="let event of events"
	class="event-card today-reg custom-margin remove--last-before"
	(click)="showDetails(event)"
>
	<div class="reg-photo col-md-3">
		<img
			class="user-avatar"
			src="{{
				event.userImageUrl || '/assets/images/icons/personalappointment.svg'
			}}"
		/>
	</div>
	<div class="reg-data col-md-9 shadow">
		<div class="col-md-10" style="margin: 5px 0 5px">
			<p
				class="sec-title"
				title="{{
					event.status
						? event.status !== 'reserved'
							? event.userName
							: ('GENERAL.PENDING' | translate)
						: event.description
				}}"
			>
				{{
					event.status
						? event.status !== 'reserved'
							? event.userName
							: ('GENERAL.PENDING' | translate)
						: event.description
				}}
			</p>
			<p class="sec-subtitle ev-{{ event.status }}">
				<fa-icon *ngIf="event.status" [icon]="icons[event.status]"></fa-icon>
				<fa-icon
					*ngIf="event.status === 'reschedule_request'"
					[icon]="{
						clock: !event.userRequestedReschedule,
						check: event.userRequestedReschedule
					}"
				></fa-icon>
				{{ event.statusText }}
			</p>
		</div>
		<div class="col-md-2 reg-hours">
			{{
				event.startTime ||
					dateTime.getFormatedHoursAlt(
						event.startDate.getHours(),
						event.startDate.getMinutes()
					)
			}}
		</div>
	</div>
</div>
